export const FETCH_AGENCIES = 'agencies/FETCH_AGENCIES'
export const CREATE_AGENCY = 'agencies/CREATE_AGENCY'
export const UPDATE_AGENCY = 'agencies/UPDATE_AGENCY'
export const CLEAR_AGENCIES_STATE = 'agencies/CLEAR_AGENCIES_STATE'
